import {Component, OnInit} from '@angular/core';
import {AppConfig} from '../app.config';

@Component({
    selector: 'app-author',
    templateUrl: './author.component.html'
})
export class AuthorComponent implements OnInit {
    public author: any = {};

    constructor() {
        AppConfig.instance.getAllTextBlocks(textblocks => {
            this.author = textblocks['long_about_author'];
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/author/author.component.ts